<p-selectButton
  [formControl]="$any(formControl)"
  [formlyAttributes]="field"
  [options]="props.options | formlySelectOptions: field | async"
  [optionLabel]="props.optionLabel || 'label'"
  [optionValue]="props.optionValue || 'value'"
  [allowEmpty]="props.allowEmpty ?? true"
  [multiple]="props.multiple ?? false"
  [readonly]="props.readonly"
  (onChange)="props.change && props.change(field, $event)"
></p-selectButton>
